import { fetch } from '@atlassian/eoc-fetch';

import type {
	GetUserRightsResponse,
	UserAccessRights,
} from '../../../common/mocks/user-access-rights/types';
import { UrlHelper } from '../../../common/utils/url-helper';

export const getUserRights = (teamId?: string | null): Promise<UserAccessRights> => {
	return fetch<GetUserRightsResponse>(
		UrlHelper(`/v1/entity-sync/unified/rights`, {
			teamId,
		}),
	).then((response) => response.data.userAccessRights);
};
